(() => {
  const removeLegacyList = (accordion) => {
    const descriptionRow = accordion.previousElementSibling;
    if (!descriptionRow?.classList.contains("accordion")) return;
    if (descriptionRow.querySelector(".accordion__label")?.textContent?.trim() !== "Description") return;
    const description = descriptionRow.querySelector(".accordion__content");
    if (!description) return;
    for (const child of Array.from(description.children)) {
      const heading = child.textContent?.replace(/\s+/g, " ").trim().replace(/:$/, "").toLowerCase();
      const list = child.nextElementSibling;
      if (heading === "key features" && list && /^(UL|OL)$/.test(list.tagName)) {
        list.remove();
        child.remove();
        break;
      }
    }
  };

  const load = async (accordion) => {
    const productId = accordion.dataset.productId;
    if (!/^\d+$/.test(productId || "")) return;
    try {
      const url = `/apps/charterhouse-discovery/product-features?product_id=${encodeURIComponent(productId)}`;
      const response = await fetch(url, { credentials: "same-origin" });
      if (!response.ok) return;
      const payload = await response.json();
      if (!Array.isArray(payload.features) || !payload.features.length) return;

      const list = accordion.querySelector(".accordion__content ul");
      const content = accordion.querySelector(".accordion__content");
      const label = accordion.querySelector(".accordion__label");
      const inner = accordion.querySelector(".accordion__inner");
      if (!list || !content || !label || !inner) return;
      for (const feature of payload.features.slice(0, 5)) {
        if (typeof feature !== "string") continue;
        const item = document.createElement("li");
        item.textContent = feature;
        list.append(item);
      }
      if (!list.children.length) return;

      removeLegacyList(accordion);
      inner.dataset.open = "true";
      label.setAttribute("aria-expanded", "true");
      content.setAttribute("aria-hidden", "false");
      content.style.removeProperty("display");
      accordion.style.removeProperty("display");
    } catch {
      // Keep the approved-features row hidden if the Preview service is unavailable.
    }
  };

  const ready = () => {
    document.querySelectorAll("[data-discovery-key-features]").forEach(load);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ready, { once: true });
  else ready();
})();
